import React, { useState, useEffect, memo, useLayoutEffect } from 'react';
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";

const CropboxContainer = memo((inProps) => {
  const { children, ...restProps } = inProps;
  const cropperStore = useCropperStore();
  const [containerStyle, setContainerStyle] = useState({});

  const updateContainerStyle = () => {
    if (cropperStore?.element?.cropper) {
      const cropBoxData = cropperStore.element.cropper.getCropBoxData();
      setContainerStyle({
        position: 'absolute',
        left: `${cropBoxData.left}px`,
        top: `${cropBoxData.top}px`,
        width: `${cropBoxData.width}px`,
        height: `${cropBoxData.height}px`,
        boxSizing: 'border-box',
        zIndex: 1,
        // pointerEvents: 'none',
        // border: '4px solid pink'
      });
    }
  };

  useLayoutEffect(() => {
    updateContainerStyle();
  }, [cropperStore.preset, cropperStore.action]);

  useEffect(() => {
    updateContainerStyle();
    const handleResize = () => {
      updateContainerStyle();
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [cropperStore?.element?.cropper]);
  
  return (
    <div style={containerStyle} {...restProps}> 
      {children}
    </div>
  );
});

export default CropboxContainer;